import React, { useState, useEffect } from 'react'
import './Document.css'
import PropTypes from 'prop-types'
import SwipeableViews from 'react-swipeable-views'
import DocumentTable from '../../component/document/DocumentTable'
import RoleMenu from '../../utilities/roleMenu/RoleMenu'
//MUI
import { useTheme } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'
//Redux
import { setTitle } from '../../redux'
import { useDispatch, useSelector } from 'react-redux'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
      style={{ position: 'relative', minHeight: '400px' }}
    >
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  }
}

////////////////////////////////////////////////////////////////////////////////////////

function ViewDocumentTable() {
  const user = useSelector((state) => state.user)

  const dispatch = useDispatch()

  const theme = useTheme()
  const [value, setValue] = useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const handleChangeIndex = (index) => {
    setValue(index)
  }

  useEffect(() => {
    dispatch(setTitle('Document Table'))
  }, [])

  return (
    <div className='document-container'>
      {user.credentials.role === 'Signer' && (
        <div className='document-role-menu'>
          <RoleMenu />
        </div>
      )}

      <AppBar position='static' color='default' style={{ borderRadius: '5px 5px 5px 5px' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor='primary'
          textColor='primary'
          variant='scrollable'
          aria-label='full width tabs example'
        >
          <Tab label={<span>Pending</span>} {...a11yProps(0)} style={{ outline: 'none' }} />
          <Tab label={<span>Completed</span>} {...a11yProps(1)} style={{ outline: 'none' }} />
          <Tab label={<span>Rejected</span>} {...a11yProps(2)} style={{ outline: 'none' }} />
          <Tab label={<span>Expired</span>} {...a11yProps(3)} style={{ outline: 'none' }} />
          <Tab label={<span>All</span>} {...a11yProps(4)} style={{ outline: 'none' }} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
        style={{ height: '90%', width: '100%' }}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <DocumentTable type='Pending' />
        </TabPanel>

        <TabPanel value={value} index={1} dir={theme.direction}>
          <DocumentTable type='Completed' />
        </TabPanel>

        <TabPanel value={value} index={2} dir={theme.direction}>
          <DocumentTable type='Rejected' />
        </TabPanel>

        <TabPanel value={value} index={3} dir={theme.direction}>
          <DocumentTable type='Expired' />
        </TabPanel>

        <TabPanel value={value} index={4} dir={theme.direction}>
          <DocumentTable type='All' />
        </TabPanel>
      </SwipeableViews>
    </div>
  )
}

export default ViewDocumentTable
